import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'quarterly-dollar-overview',
    pathMatch: 'full',
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'quarterly-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quarterly_psbu.json' },
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'opportunity-simulator',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-simulator-config.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opportunity-overview-config.json' },
  },
  {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },

  {
    path: 'customer-overview',
    component: DashboardComponent,
    data: { configFile: 'customer-overview.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-sales-bridge',
    component: DashboardComponent,
    data: { configFile: 'cspec-sales-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'yearly-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/yearly-overview.json' },
  },
  {
    path: 'quarterly-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/quarterly-overview.json' },
  },
  {
    path: 'quarterly-detailed-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/quarterly-detailed-view.json' },
  },
  {
    path: 'quarterly-dollar-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/quarterly-dollar-overview.json' },
  },
  {
    path: 'quarterly-detailed-dollar-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/quarterly-detailed-dollar-view.json' },
  },
  {
    path: 'yearly-detailed-dollar-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/yearly-detailed-dollar-view.json' },
  },
  {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/yearly-detailed-view.json' },
  },
  {
    path: 'yearly-dollar-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/yearly-dollar-overview.json' },
  },
  {
    path: 'chat',
    component: ChatComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config/chat-config.json' },
  },
  //msbi routes
  {
    path: 'msbi-quarterly-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-quarterly-overview.json' },
  },
  {
    path: 'msbi-quarterly-detailed-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-quarterly-detailed-view.json' },
  },
  {
    path: 'static-screen',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/static-screen.json' },
  },
  {
    path: 'static-screen-we',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/static-screen-2.json' },
  },
  {
    path: 'msbi-quarterly-dollar-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-quarterly-dollar-view.json' },
  },
  {
    path: 'msbi-yearly-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-yearly-overview.json' },
  },
  {
    path: 'msbi-yearly-detailed-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-yearly-detailed-view.json' },
  },
  {
    path: 'msbi-yearly-dollar-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/msbi-yearly-dollar-view.json' },
  },
  //margin views
  {
    path: 'margin-segment-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/margin-segment-overview.json' },
  },
  {
    path: 'margin-region-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/margin-region-overview.json' },
  },
  {
    path: 'margin-engine-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/margin-engine-overview.json' },
  },
  {
    path: 'ecc-wise-margin',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu/ecc-wise-margins.json' },
  },
  {
    path: '**',
    redirectTo: 'quarterly-dollar-overview',
  },

];
